<template>
  <modal class="q-modal qos-item" name="qos-item-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="350"
       :min-width="350"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <loading :mask=true :size="'middle'" :isWhite=true v-if="isShowLoading"/>
      <div class="modal-header">{{modalTitle}}</div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="group-table">
            <fixed-table ref="queue" :data="priorityList" :use-page="false" :header-height="40">
              <div id="right-header" class="right-header" slot="right-header">
                <column id="queue" style="width: 40%;">{{typeTitle}}</column>
                <column id="queueScope" style="width: 60%; display: inline-block" class="queue">{{$t('qos.queue')}}
                  <span style="padding-left:5px;color:#195A87;">{{$t('qos.queueScope')}}</span>
                  <div class="icon-info info-color ft-14" @click="onInfoClick"/>
                </column>
              </div>
              <template slot="rows" slot-scope="props">
                <div class="link-row">
                  <row class="right" :props="props">
                    <div class="data" style="width: 40%;">{{props.data.key | getType}}</div>
                    <div class="data priority" style="width: 60%;">
                      <div class="icon-line" @click="decressPriority(props)" :class="{'disabled': (props.data.val === 1)}"></div>
                      <input :name="'priority' + props.index" class="form-control priority-input" :class="{'error': errors.has('priority' + props.index)}" v-model="props.data.val" v-validate="'required|numeric|max_value:8|min_value:1'" min="1" max="8" maxlength="1" @change="onBlur" @input="onInput" @keypress="onlyNumber">
                      <div class="icon-plus" @click="incressPriority(props)" :class="{'disabled': (props.data.val === 8)}"></div>
                    </div>
                  </row>
                </div>
              </template>
            </fixed-table>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onSaveClick" :disabled="!isEnable" :title="$t('save')">{{$t('save')}}</button>
          <button class="q-button" @click="onClose" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
export default {
  name: 'qos-item',
  props: {
    selectType: String,
    onChange: Function
  },
  components: {
    fixedTable,
    row,
    column
  },
  filters: {
    getType (data) {
      if (data >= 100 && data < 164) {
        return data - 100
      } else if (data >= 10 && data < 18) {
        return data - 10
      }
    }
  },
  data () {
    return {
      modalname: 'qos-item-modal',
      isEnable: false,
      priorityList: null,
      originalList: null,
      isShowLoading: false
    }
  },
  watch: {
    selectType: {
      handler (value) {
        if (value) {
          this.getData()
        }
      }
    }
  },
  methods: {
    ...mapActions(['getQosDscp', 'setQosDscp', 'getQosPcp', 'setQosPcp']),
    ...mapMutations(['openModal', 'closeModal']),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let width = document.getElementById('right-header').clientWidth
      let scrollw = document.getElementById('queue').scrollWidth + document.getElementById('queueScope').scrollWidth
      let tempw = (scrollw > width) ? 450 : 350
      let temph = (height > 475) ? 475 : height - 90
      if (modal) {
        modal.style.height = temph + 'px'
        modal.style.width = tempw + 'px'
        modal.style.top = 'calc(50% - ' + (temph / 2) + 'px'
      }
      this.$refs.scrollbar.onResize()
    },
    getData: function () {
      if (this.selectType === 'dscp') {
        this.getQosDscp()
          .then((res) => {
            if (res.data && res.data.error_code === 200) {
              this.priorityList = res.data.result
              this.originalList = JSON.parse(JSON.stringify(res.data.result))
              this.isShowLoading = false
            }
          }).catch((err) => {
            this.$log.error(err)
          })
      } else {
        this.getQosPcp()
          .then((res) => {
            if (res.data && res.data.error_code === 200) {
              this.priorityList = res.data.result
              this.originalList = JSON.parse(JSON.stringify(res.data.result))
              this.isShowLoading = false
            }
          }).catch((err) => {
            this.$log.error(err)
          })
      }
    },
    decressPriority: function (props) {
      let idx = props.index
      let priority = props.data.val
      if (priority > 1) {
        this.priorityList[idx].val--
        this.onInput(props)
      }
    },
    incressPriority: function (props) {
      let idx = props.index
      let priority = props.data.val
      if (priority < 8) {
        this.priorityList[idx].val++
        this.onInput(props)
      }
    },
    checkValidation: function (fieldName) {
      this.priorityList.forEach(element => {
        if (element.val === '') {
          element['val'] = 1
        } else {
          element['val'] = Number(element['val'])
        }
      })
      if (fieldName) {
        setTimeout(() => {
          this.$validator.validate(fieldName).then((result) => {
            if (result) {
              if (!this.$compareObj(this.priorityList, this.originalList)) {
                this.isEnable = true
              } else {
                this.isEnable = false
              }
            } else {
              this.isEnable = result
            }
          })
        }, 100)
      } else {
        if (!this.$compareObj(this.priorityList, this.originalList)) {
          this.isEnable = true
        } else {
          this.isEnable = false
        }
      }
    },
    onSelect ($event) {
      $event.target.onSelect = true
    },
    onBlur ($event) {
      $event.target.onSelect = false
    },
    onInput: function ($event) {
      let temp = /^[1-8]{1}$/
      let value = ($event.key) ? parseInt($event.key) : ($event.data) ? $event.data.val : ''
      let name = ($event.target) ? $event.target.name : 'priority' + $event.index
      if (!temp.test(value) || value === '') {
        this.isEnable = false
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.checkValidation(name)
        } else {
          this.isEnable = false
        }
      })
    },
    checkChangedItem: function () {
      let data = []
      this.priorityList.forEach((element, index) => {
        if (element.val !== this.originalList[index].val) {
          data.push({
            key: element.key,
            val: element.val
          })
        }
      })
      return data
    },
    onSaveClick: function () {
      let changedData = this.checkChangedItem()
      let changedDataLength = changedData.length
      this.isShowLoading = true
      this.isEnable = false
      if (this.selectType === 'dscp') {
        changedData.forEach(element => {
          this.setQosDscp(element)
            .then((res) => {
              if (res.data && res.data.error_code === 200) {
                changedDataLength--
              }
              if (changedDataLength === 0) {
                this.onClose()
              }
            }).catch((err) => {
              this.$log.error(err)
            })
        })
      } else {
        changedData.forEach(element => {
          this.setQosPcp(element)
            .then((res) => {
              if (res.data && res.data.error_code === 200) {
                changedDataLength--
              }
              if (changedDataLength === 0) {
                this.onClose()
              }
            }).catch((err) => {
              this.$log.error(err)
            })
        })
      }
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.isEnable = false
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
      this.onChange()
    },
    onInfoClick: function (event) {
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        this.$store.commit('updateInfoData', {
          message: this.infoMessage,
          event: event
        })
      }
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode < 49 || keyCode > 56) {
        $event.preventDefault()
      }
    }
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      portNumber: state => state.module.portNum
    }),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    modalTitle () {
      if (this.selectType === 'dscp') {
        return this.$t('qos.editDscp')
      } else {
        return this.$t('qos.editCos')
      }
    },
    typeTitle () {
      if (this.selectType === 'dscp') {
        return this.$t('qos.dscpType')
      } else {
        return this.$t('qos.pcpType')
      }
    },
    infoMessage () {
      let message = []
      if (this.selectType === 'dscp') {
        message.push({text: this.$t('qos.dscpInfo')})
      } else {
        message.push({text: this.$t('qos.cosInfo')})
      }
      return message
    }
  }
}
</script>

<style lang="scss" scoped>
.qos-item {
  .right-header {
    width: min-content;
    .queue {
      display: inline-block;
      padding: 0px;
    }
  }
  .data.priority {
    display: flex !important;
    justify-content: start;
    margin: auto;
    padding-left: 0px !important;
    .priority-input {
      width: 50px;
      margin: 0px 10px;
    }
    div {
      margin: auto 0px;
      cursor: pointer;
      &.disabled {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QosItem.vue